import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Auth from './Auth';
import reportWebVitals from './reportWebVitals';
import 'tachyons';
import { Auth0Provider } from "@auth0/auth0-react";
import ambiente from './components/Ambiente';
import cdnBaseUrl from './components/Cdn';

if (!cdnBaseUrl) {
  throw new Error('variabile "cdnBaseUrl" non configurata');
}

if (!ambiente) {
  throw new Error('variabile "ambiente" non configurata');
}


ReactDOM.render(
  <Auth0Provider
    domain="damiano.eu.auth0.com"
    clientId="0L3Mu19kEeQLUUmkcVwSYGCvOaaAxOG9"
    redirectUri={window.location.origin}
    audience="https://vs-translations-api.damianofenoglio.com"
  >
    <Auth />
  </Auth0Provider>,
  document.getElementById("root")
);

reportWebVitals();
